$(document).ready(function () {
    $feedbackLinks = $('.promotion-share-link');
    if (!$feedbackLinks.length) return false;
    $feedbackLinks.on('click', function () {
        var textToReplace = $('.screen-title-title').text();
        if (textToReplace == 'undefined' || textToReplace == '') {
            textToReplace = document.title != '' ? document.title : '';
        }
        var modalHeading = $('#prodNameLabel').text().replace('{prodNameLabel}', textToReplace);
        $('#prodNameLabel').text(sanitizeHtmlStrings(modalHeading));

        if ($("textarea[data-sc-field-name='txtSubject']") && $("textarea[data-sc-field-name='txtSubject']").length > 0) {
            $("textarea[data-sc-field-name='txtSubject']").text(sanitizeHtmlStrings(textToReplace));
        } else {
            $("input[data-sc-field-name='txtSubject']").val(sanitizeHtmlStrings(textToReplace));
        }
        var txtSubjectSection = $('.txtSubject_section');
        if (txtSubjectSection !== 'undefined' && txtSubjectSection.length > 0) {
            txtSubjectSection.text(sanitizeHtmlStrings(textToReplace));
        }
    });
});

// for chemical share this page
$(document).ready(function () {
    $chemicalFormsLinks = $('[data-bs-target="#Sharethispage"]');
    if (!$chemicalFormsLinks.length) return false;
    $chemicalFormsLinks.on('click', function (e) {
        var dynamicText = '{prodNameLabel}';
        var headingElement = $('.b06-heading h3');
        var textToReplace = "";
        if (headingElement.length == 0) {
            headingElement = $('.screen-title-title.field-title');
        }
        if (headingElement && headingElement.length) {
            textToReplace = $(headingElement).text();
        }
        if (textToReplace == 'undefined' || textToReplace == '') {
            textToReplace = document.title != '' ? document.title : '';
        }
        var headingHtml = $('#Sharethispage #prodNameLabel').html();
        if (headingHtml && headingHtml.indexOf(dynamicText) > -1) {
            $('#Sharethispage #prodNameLabel').html(sanitizeHtmlStrings(headingHtml.replace('{prodNameLabel}', '<span class="dynamic-text">' + textToReplace + '</span>')));
        } else {
            $('#Sharethispage #prodNameLabel').find('.dynamic-text').text(sanitizeHtmlStrings(textToReplace));
        }

        if ($("#Sharethispage textarea[data-sc-field-name='txtSubject']") && $("#lightbox-share textarea[data-sc-field-name='txtSubject']").length > 0) {
            $("#Sharethispage textarea[data-sc-field-name='txtSubject']").text(sanitizeHtmlStrings(textToReplace));
        } else {
            $("#Sharethispage input[data-sc-field-name='txtSubject']").val(sanitizeHtmlStrings(textToReplace));
        }
        var txtSubjectSection = $('.txtSubject_section');
        if (txtSubjectSection !== 'undefined' && txtSubjectSection.length > 0) {
            txtSubjectSection.text(sanitizeHtmlStrings(textToReplace));
        }
    });
});

// Share options in the custom list
$(document).ready(function () {
    var dynamicText = '{prodNameLabel}';
    $feedbackLinks = $('[data-bs-target="#shareform01"][data-bs-toggle="modal"]:not(.pds-share-link)');
    if (!$feedbackLinks.length) return false;
    $feedbackLinks.on('click', function (e) {
        if ($(e.currentTarget).length && $(e.currentTarget).parents(".div-table-row").length) {
            var headingHtml = $('#shareform01 #prodNameLabel').html();
            var temp = $(e.currentTarget).parents(".div-table-row").find(".resource-list-description .field-description");
            var pdfName = temp.length > 0 ? $(temp[0]).text() : '';
            if (pdfName == 'undefined' || pdfName == '') {
                pdfName = document.title != '' ? document.title : '';
            }
            if (headingHtml.indexOf(dynamicText) > -1) {
                $('#shareform01 #prodNameLabel').html(sanitizeHtmlStrings(headingHtml.replace('{prodNameLabel}', '<span class="dynamic-text">' + pdfName + '</span>')));
            } else {
                $('#shareform01 #prodNameLabel').find('.dynamic-text').text(sanitizeHtmlStrings(pdfName));
            }
            //$("#shareform01 input[data-sc-field-name='txtSubject']").val(pdfName);
            if ($("#shareform01 textarea[data-sc-field-name='txtSubject']") && $("#shareform01 textarea[data-sc-field-name='txtSubject']").length > 0) {
                $("#shareform01 textarea[data-sc-field-name='txtSubject']").text(sanitizeHtmlStrings(pdfName));
            } else {
                $("#shareform01 input[data-sc-field-name='txtSubject']").val(pdfName);
            }
            var txtSubjectSection = $('.txtSubject_section');
            if (txtSubjectSection !== 'undefined' && txtSubjectSection.length > 0) {
                txtSubjectSection.text(sanitizeHtmlStrings(pdfName));
            }
            var shareUrl = '';
            var domain = '';
            var protocol = '';
            var siteUrl = '';
            siteUrl = window.location.href.split('/');
            domain = siteUrl[2]; protocol = siteUrl[0];
            //protocol = window.location.href;
            var linkElement = $(e.currentTarget).parents(".div-table-row").find('a[title*="File"]').eq(0);
            if (linkElement == 'undefined' || linkElement.length <= 0) {
                linkElement = $(e.currentTarget).parents(".div-table-row").find('a').eq(0);
            }
            if (linkElement && linkElement != 'undefined') {
                shareUrl = $(linkElement).attr('href');
                if ($("input[data-sc-field-name='shareDocumentUrl']") != 'undefined') {
                    $("input[data-sc-field-name='shareDocumentUrl']").val(protocol + "//" + domain + shareUrl);
                }
            } else {
                linkElement = $(this).closest('.div-table-row').find('[title="File"]').eq(2);
                if (linkElement == 'undefined' || linkElement.length <= 0) {
                    linkElement = $(e.currentTarget).parents(".div-table-row").find('[title="File_1"]').eq(2);
                }
                if (linkElement && linkElement != 'undefined') {
                    shareUrl = $(linkElement).attr('href');
                    if ($("input[data-sc-field-name='shareDocumentUrl']") != 'undefined') {
                        $("input[data-sc-field-name='shareDocumentUrl']").val(protocol + "//" + domain + shareUrl);
                    }
                }
            }
        }
    });
});


// Share to a collegue
$(document).ready(function () {
    var dynamicText = '{prodNameLabel}';
    $feedbackLinks = $('[data-bs-target="#lightbox-share"]');
    if (!$feedbackLinks.length) return false;
    $feedbackLinks.on('click', function (e) {
        var headingElement = $('.b06-heading h1');
        var textToReplace = "";
        if ($(this).hasClass('ides-share-link')) {
            textToReplace = $(e.target).closest('tr').find('td .ides-subject').text().trim();
            $('.PDSurlHidden').val($(e.target).closest('tr').find('.ides-pds-link').attr('href'));
            $('.Sales-specURLHidden').val($(e.target).closest('tr').find('.ides-sales-spec-link').attr('href'));
        }
        if (headingElement.length == 0) {
            headingElement = $('.screen-title-title.field-title');
        }
        if ((textToReplace == 'undefined' || textToReplace == '') && headingElement && headingElement.length) {
            textToReplace = $(headingElement).text();
        }
        if (textToReplace == 'undefined' || textToReplace == '') {
            textToReplace = document.title != '' ? document.title : '';
        }
        var headingHtml = $('#lightbox-share #prodNameLabel').html();
        if (headingHtml && headingHtml.indexOf(dynamicText) > -1) {
            $('#lightbox-share #prodNameLabel').html(sanitizeHtmlStrings(headingHtml.replace('{prodNameLabel}', '<span class="dynamic-text">' + textToReplace + '</span>')));
        } else {
            $('#lightbox-share #prodNameLabel').find('.dynamic-text').text(sanitizeHtmlStrings(textToReplace));
        }

        if ($("#lightbox-share textarea[data-sc-field-name='txtSubject']") && $("#lightbox-share textarea[data-sc-field-name='txtSubject']").length > 0) {
            $("#lightbox-share textarea[data-sc-field-name='txtSubject']").text(sanitizeHtmlStrings(textToReplace));
        } else {
            $("#lightbox-share input[data-sc-field-name='txtSubject']").val(sanitizeHtmlStrings(textToReplace));
        }
        var txtSubjectSection = $('.txtSubject_section');
        if (txtSubjectSection !== 'undefined' && txtSubjectSection.length > 0) {
            txtSubjectSection.text(sanitizeHtmlStrings(textToReplace));
        }
    });
});

$(document).ready(function () {
    var textToReplace = '';
    $feedbackLinks = $('.product-share-link');
    if (!$feedbackLinks.length) return false;
    $feedbackLinks.off('click').on('click', function () {
        var dynamicText = '{prodNameLabel}';
        var headingElement = $('[pds-heading]');
        var recommendationName = $('[recommendation-name]');
        var equipmentHeading = $('.special-screen-title-text h1');
        var fieldTitle = $('.field-title');
        if (typeof (headingElement) !== "undefined" && headingElement.length > 0) {
            textToReplace = $(headingElement).attr('pds-heading');
        }
        else {
            textToReplace = $('.screen-title-title.field-title').text();
        }
        if (typeof (recommendationName) !== "undefined" && recommendationName.length > 0) {
            textToReplace = $(recommendationName).attr('recommendation-name');
        }
        if (typeof (equipmentHeading) !== "undefined" && equipmentHeading.length > 0) {
            textToReplace = $(equipmentHeading).text();
        }
        if (textToReplace == 'undefined' || textToReplace == '' && typeof (fieldTitle) !== "undefined" && fieldTitle.length > 0) {
            //taking the first value from the list as product page has so many .field-title classes
            textToReplace = $($(fieldTitle)[0]).text();
        }
        if (textToReplace == 'undefined' || textToReplace == '') {
            textToReplace = document.title != '' ? document.title : '';
        }
        var headingHtml = $('#prodNameLabel').html();
        if ($("input[data-sc-field-name='shareDocumentUrl']") != 'undefined') {
            $("input[data-sc-field-name='shareDocumentUrl']").val('');
        }
        if (headingHtml && headingHtml.indexOf(dynamicText) > -1) {
            $('#prodNameLabel').html(sanitizeHtmlStrings(headingHtml.replace(dynamicText,
                '<span class="dynamic-text">' + textToReplace + '</span>')));
        } else {
            $('#prodNameLabel').find('.dynamic-text').text(sanitizeHtmlStrings(textToReplace));
        }
        if ($("textarea[data-sc-field-name='txtSubject']") && $("textarea[data-sc-field-name='txtSubject']").length > 0) {
            $("textarea[data-sc-field-name='txtSubject']").text(sanitizeHtmlStrings(textToReplace));
        } else {
            $("input[data-sc-field-name='txtSubject']").val(textToReplace);
        }
        var txtSubjectSection = $('.txtSubject_section');
        if (txtSubjectSection !== 'undefined' && txtSubjectSection.length > 0) {
            txtSubjectSection.text(sanitizeHtmlStrings(textToReplace));
        }
        setTimeout(function () {
            $(".modal.fade.show .sitecore-form .form-area input.form-control").first().focus();
        }, 1000);
    });
});

$('body').on('click', '.sfmc-form-databind',
    function () {
        var model = "";
        var engine = "";
        var make = "";
        var year = "";
        var URL = window.location.href;
        var pageTitle = $(document).attr('title');
        $('.product-selector-pageurl').val(URL);
        $('.product_locator_pagetitle').val(pageTitle);
        var dataAttr = $('.product-selector').attr("data-app-config");
        var modelAttr = $('.recommendations-view').attr("data-vehicleprofile");
        if (dataAttr !== undefined && modelAttr !== undefined) {
            var appConfig = JSON.parse(dataAttr);
            var modelConfig = JSON.parse(modelAttr);
            var provider = appConfig.data.providerKey;
            if (provider == 'WMI') {
                model = modelConfig.model;
                make = modelConfig.manufacturer;
                engine = modelConfig.engine;
                year = modelConfig.year_to;
            }
            else if (provider == 'Motor') {
                var itemsArray = window.location.href.split('/');
                model = itemsArray[itemsArray.length - 1];
                make = itemsArray[itemsArray.length - 2];
                year = itemsArray[itemsArray.length - 3].split('-').pop();
                engine = appConfig.response.body.attributes.engines[0].description;
            } else {
                model = modelConfig.model;
                make = modelConfig.manufacturer;
                engine = modelConfig.model + " " + modelConfig.fuel;
                year = modelConfig.year_from;
            }
            $('.product-selector-model').val(model);
            $('.product-selector-make').val(make);
            $('.product-selector-engine').val(engine);
            $('.product-selector-year').val(year);

            $('.product-selector-isproduct').val("");
            $('.product-selector-productname').val("");
            $('.product-selector-ph6code').val("");
        }
    }
);

$('body').on('click', '.btn-remind-ps',
    function () {
        var model = "";
        var engine = "";
        var make = "";
        var year = "";
        var URL = window.location.href;
        var dataAttr = $('.product-selector').attr("data-app-config");
        var appConfig = JSON.parse(dataAttr);
        var modelAttr = $('.recommendations-view').attr("data-vehicleprofile");
        var modelConfig = JSON.parse(modelAttr);
        var provider = appConfig.data.providerKey;
        if (provider == 'WMI') {
            model = modelConfig.model;
            make = modelConfig.manufacturer;
            engine = modelConfig.engine;
            year = modelConfig.year_to;
        } else {
            model = modelConfig.model;
            make = modelConfig.manufacturer;
            engine = modelConfig.model + " " + modelConfig.fuel;
            year = modelConfig.year_from;
        }

        var productsAttr = $('.ps-products-view').attr("data-products");
        var productsConfig = JSON.parse(productsAttr);
        var gpnval = $(this).attr('ps-gpn');
        var product = productsConfig.find(function (product, index) {
            if (product.gpn == gpnval) return true;
        });

        var isProduct = true;
        var productName = product.name;

        var pageTitle = $(document).attr('title');

        $('.product-selector-isproduct').val(isProduct);
        $('.product-selector-productname').val(productName);
        $('.product-selector-ph6code').val(gpnval);

        $('.product-selector-model').val(model);
        $('.product-selector-make').val(make);
        $('.product-selector-engine').val(engine);
        $('.product-selector-year').val(year);
        $('.product-selector-pageurl').val(URL);
        $('.product_locator_pagetitle').val(pageTitle);
    }
);

$('body').on('click', '.recommendations-header .link-modal',
    function () {
        var model = "";
        var engine = "";
        var make = "";
        var year = "";
        var URL = window.location.href;
        var dataAttr = $('.product-selector').attr("data-app-config");
        var appConfig = JSON.parse(dataAttr);
        var modelAttr = $('.recommendations-view').attr("data-vehicleprofile");
        var modelConfig = JSON.parse(modelAttr);
        var provider = appConfig.data.providerKey;
        if (provider == 'WMI') {
            model = modelConfig.model;
            make = modelConfig.manufacturer;
            engine = modelConfig.engine;
            year = modelConfig.year_to;
        } else {
            model = modelConfig.model;
            make = modelConfig.manufacturer;
            engine = modelConfig.model + " " + modelConfig.fuel;
            year = modelConfig.year_from;
        }

        var productsAttr = $('.ps-products-view').attr("data-products");
        var productsConfig = JSON.parse(productsAttr);

        $('.product-selector-model').val(model);
        $('.product-selector-make').val(make);
        if ($('.product-selector-engine')) {
            $('.product-selector-engine').val(engine);
        }
        $('.product-selector-year').val(year);
    }
);

(function () {
    var URL = window.location.href;
    var pageTitle = $(document).attr('title');
    if ($('.product-selector-pageurl') && $('.product-selector-pageurl').length) {
        $('.product-selector-pageurl').val(URL);
    }
    if ($('.product_locator_pagetitle') && $('.product_locator_pagetitle').length) {
        $('.product_locator_pagetitle').val(pageTitle);
    }
}(window.jQuery));

$(window).on('load', function () {
    if ($('.bv-focusable') && $('.bv-focusable').length) {
        $("span").parent(".bv-focusable").attr("role", "presentation");
    }
});

(function ($) {
    var url = $("input.postalcode").attr('data-api-url');
    var classname = $("input.postalcode").attr('data-target-binding-class');
    var errmsg = $("input.postalcode").attr('data-api-errormessage');
    $(".api-errormessage").css('display', 'none');
    $(".api-errormessage").html(errmsg);
    $(".api-errormessage").addClass('field-validation-error');
    $("input.postalcode").keyup(function () {
        var inputvalue = $(this).val();
        var apiurl = url;
        apiurl = apiurl.replace("{0}", inputvalue);
        var isvalid = (/^[0-9]{6}$/.test(inputvalue));
        if (inputvalue.length == 6 && isvalid) {
            $.ajax({
                type: 'GET',
                url: apiurl,
                success: function (data, status, xhr) {
                    if (data.results.length > 0) {
                        var value = data.results[0].BLK_NO + ' ' + data.results[0].ROAD_NAME;
                        $("input." + classname).val(value);
                        $("input." + classname).focus();
                        $(".api-errormessage").css('display', 'none');
                        $(".api-errormessage").removeClass('invalid-field');
                        $('.form-submit').removeAttr('disabled');
                    } else {
                        $("input." + classname).val('');
                        $(".api-errormessage").css('display', 'block');
                        $(".api-errormessage").addClass('invalid-field');
                    }
                }
            });
        } else {
            $("input." + classname).val('');
        }
    });
}(window.jQuery));

